import { type CreateBlockData } from '@/lib/builder/types'

import {
  type ReservationEmbedSection,
  type ReservationEmbedSectionCreate,
} from '../../../WebsiteBuilder.types'

export const createReservationEmbedData = ({
  brandId,
}: CreateBlockData<ReservationEmbedSection>): ReservationEmbedSectionCreate => ({
  brandId,
  params: {
    providerId: '',
    providerType: 'opentable',
  },
  type: 'reservation-embed',
})
